import React from "react";
import { cva, type VariantProps } from "class-variance-authority";

const gradientContainerVariants = cva("", {
  variants: {
    gradient: {
      "purple-black": " from-purple to-black",
      "purple-purple": " from-purple to-purple-dark",
      none: "",
    },
    direction: {
      "to-r": "bg-linear-to-r",
      "to-l": "bg-linear-to-l",
      "to-t": "bg-linear-to-t",
      "to-b": "bg-linear-to-b",
      "to-br": "bg-linear-to-br",
      "to-bl": "bg-linear-to-bl",
      "to-tr": "bg-linear-to-tr",
      "to-tl": "bg-linear-to-tl",
    },
  },
  defaultVariants: {
    gradient: "purple-black",
    direction: "to-b",
  },
});

interface GradientContainerProps extends VariantProps<
  typeof gradientContainerVariants
> {
  children?: React.ReactNode;
  className?: string;
  as?: React.ElementType;
}

export const GradientContainer: React.FC<GradientContainerProps> = ({
  children,
  gradient = "purple-black",
  direction = "to-b",
  className = "",
  as: Component = "div",
}) => {
  return (
    <Component
      className={gradientContainerVariants({
        gradient,
        direction,
        className,
      })}
    >
      {children}
    </Component>
  );
};
